import { render, staticRenderFns } from "./GiftGoalWidgetPreview.vue?vue&type=template&id=4f73c1ed"
import script from "./GiftGoalWidgetPreview.vue?vue&type=script&lang=js"
export * from "./GiftGoalWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports